import _default from './Item';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ../node_modules/semantic-ui-react/dist/es/views/Item/index.js
// module id = 914
// module chunks = 0